// DO NOT MODIFY! THIS FILE IS AUTOGENERATED BY generate-endpoint-spec.util.ts

import { RequestHandler } from 'express';

export const TSpecRoute_getAttendanceBonusHistory = () => "/attendance-bonus/history";

export type TSpecHandler_getAttendanceBonusHistory = RequestHandler<TSpecPathGetAttendanceBonusHistory, any, TSpecBodyGetAttendanceBonusHistory, TSpecQueryGetAttendanceBonusHistory, {}>;

export interface TSpecPathGetAttendanceBonusHistory {  }

export interface TSpecBodyGetAttendanceBonusHistory {}

export interface TSpecQueryGetAttendanceBonusHistory {
  /**
   * Comma separated list of statuses to include
   */
  status?: string;
  limit?: number;
  skip?: number;
  startDate?: string;
  endDate?: string;
  userId?: string;
  AppVersion?: string;
  AppUser?: string;
}
